import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getFormValues , reduxForm } from 'redux-form';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import DataSection from '../../comps/DataSection/DataSection';
import formFields from '../config/formFields';
// import geoPolData from '../config/geoPolData';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';

class SelectLevel extends Component{ 

    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        }
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }
    
    render(){
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'uplevelRenewal';
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                        <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.ONBUplevelInfo" /></Heading>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={formFields.section1} sectionName="section1" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

SelectLevel = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(SelectLevel);

function mapStateToProps(state) {
return {
        formStates: getFormValues('uplevelRenewal')(state) // here 'form' is the name you have given your redux form 
}
}

export default connect(mapStateToProps)(SelectLevel);